<template>
  <div class="xxb-main">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加Banner</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="xuhao"
                label="序号"
                width="50"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="图片"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="width: 80px;height: 40px;"
                    :preview-src-list="[scope.row.imgurl]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="url"
                label="URL"
                min-width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="margin-top: 20px"
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="rules">
        <el-form-item label="序号" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="是否跳转" prop="islink">
          <el-radio v-model="editForm.islink" :label="0">不跳转</el-radio>
          <el-radio v-model="editForm.islink" :label="1">跳转</el-radio>
        </el-form-item>
        <el-form-item label="网址URL" prop="url" v-if="editForm.islink===1">
          <el-input v-model="editForm.url" maxlength="1500" placeholder="请输入网址URL" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="图片" prop="img">
          <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片建议尺寸686*308px</span>
          <SingleImg :key="imgKey" v-model="editForm.img" :oldurl="editForm.oldImg_url" :size="[343,154]"></SingleImg>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import { getUser } from '@/utils/auth'
import { getLifeBannerList, delLifeBannerList, editLifeBannerList } from '@/api/work'
import SingleImg from '@/components/upload/SingleImg'
export default {
  name: 'lifebanner',
  components: { SingleImg },
  computed: {
    user: getUser
  },
  data() {
    return {
      loading: false,
      searchForm: {
        search: ''
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      editForm: {
        bid: null,
        img: null,
        xuhao: 0,
        islink: 0,
        url: '',
        oldImg_url: ''
      },
      rules: {
        url: [{ required: true, message: '请输入网址', trigger: 'blur' }],
        img: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },
      courseData: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      imgKey: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search
      }
      getLifeBannerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    editRow(row) {
      this.imgKey = new Date().getTime()
      if (row == null) {
        this.editTitle = '添加Banner'
        this.editForm.bid = 0
        this.editForm.img = null
        this.editForm.xuhao = 0
        this.editForm.islink = 0
        this.editForm.url = ''
        this.editForm.oldImg_url = ''
      } else {
        this.editTitle = '修改Banner'
        this.editForm.bid = row.bid
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.xuhao = row.xuhao
        this.editForm.islink = row.islink
        this.editForm.url = row.url
        this.editForm.oldImg_url = row.imgurl
      }
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            const data = {
              bid: this.editForm.bid,
              imgid: this.editForm.img.imgid,
              xuhao: this.editForm.xuhao,
              islink: this.editForm.islink,
              url: this.editForm.url
            }
            this.eidtLoading = true
            editLifeBannerList(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.Search()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delLifeBannerList({ bid: row.bid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .xxb-main{
  }
</style>
